import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { installClientErrorReporting } from "@shared/clientErrors";
// The portal renders in the premise's OWN template typeface (PORTAL-5), which
// can be any family in the scheme catalogue - so it needs the catalogue, not
// one font. Relative, not "@shared/...": the standalone foyer-family build
// aliases @shared to foyer-shared/dist (tsc output: no CSS, no font files).
// See the shared-alias-build-lanes note.
import "../shared/fonts/scheme.css";
import "./styles.css";

// Uncaught errors and unhandled rejections go to POST /api/client-errors,
// grouped server-side and listed under Settings > Client errors. Installed
// before render so a crash in the first render is caught too.
installClientErrorReporting(
  "family",
  (import.meta.env.VITE_APP_VERSION as string | undefined) ?? "dev"
);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
